var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#678134;}\r\n\t.st2{fill:#1B7D9F;}\r\n\t.st3{fill:#934D4F;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#8B7734;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 16,
    height: 16
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.01,6.3l-5.94,5.94c-0.2,0.2-0.53,0.2-0.73,0L2.99,8.88c-0.2-0.2-0.2-0.53,0-0.73l0.73-0.73 c0.2-0.2,0.53-0.2,0.73,0l2.26,2.26l4.84-4.84c0.2-0.2,0.53-0.2,0.73,0l0.73,0.73C13.21,5.77,13.21,6.1,13.01,6.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "White"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55758",
    className: "st4",
    d: "M8,0C3.58,0,0,3.58,0,8c0,4.42,3.58,8,8,8s8-3.58,8-8C16,3.58,12.42,0,8,0z M13.01,6.3 l-5.94,5.94c-0.2,0.2-0.53,0.2-0.73,0L2.99,8.88c-0.2-0.2-0.2-0.53,0-0.73l0.73-0.73c0.2-0.2,0.53-0.2,0.73,0l2.26,2.26l4.84-4.84 c0.2-0.2,0.53-0.2,0.73,0l0.73,0.73C13.21,5.77,13.21,6.1,13.01,6.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmSuccess);
export default __webpack_public_path__ + "static/media/TM_Success.7f569f509e1cb8ea6181b72a13f2e572.svg";
export { ForwardRef as ReactComponent };